import React from "react";
import { repaymentMethods, usCurrency, usDateFormat } from "../../../../utils";
import { isNull } from "lodash";
import payrollFrequency from "../../../../mocks/payrollFrequency.json";

const ModificationDetails = ({ loanActivationDate, data }) => {
  let modifiedData = data?.reAmortizationRequestDetails;
  return (
    <>
      {modifiedData?.modificationType == 2 ? (
        <div className="row-loan-refinance fw-500 ft-14">
          Loan was refinanced on {usDateFormat(loanActivationDate)} with loan
          amount of {usCurrency(modifiedData?.loanRequestAmount)}{" "}
          {!isNull(modifiedData?.periodicPayment) &&
            `and periodic payment of ${usCurrency(
              modifiedData?.periodicPayment
            )}`}{" "}
          {!isNull(modifiedData?.interestRate) &&
            `and interest rate ${modifiedData?.interestRate}%`}{" "}
          {!isNull(modifiedData?.tenureYears) &&
            !isNull(modifiedData?.tenureMonths) &&
            `and tenure of ${modifiedData?.tenureYears} years and ${modifiedData?.tenureMonths} months`}
        </div>
      ) : modifiedData?.modificationType == 1 ? (
        <div className="row-loan-refinance fw-500 ft-14">
          Loan was reamortized on {usDateFormat(loanActivationDate)} with{" "}
          {!isNull(modifiedData?.periodicPayment) &&
            `periodic payment of ${usCurrency(
              modifiedData?.periodicPayment
            )}`}{" "}
          {!isNull(modifiedData?.repaymentMethod) &&
            `and repayment method of ${
              repaymentMethods.find(
                (_) => _.value == modifiedData?.repaymentMethod
              )?.label
            }`}{" "}
          {!isNull(modifiedData?.repaymentFrequency) &&
            `and ${
              payrollFrequency.data.find(
                (_) => _.value == modifiedData?.repaymentFrequency
              )?.label
            } repayment frequency`}{" "}
          {!isNull(modifiedData?.tenureYears) &&
            !isNull(modifiedData?.tenureMonths) &&
            `and tenure of ${modifiedData?.tenureYears} years and ${modifiedData?.tenureMonths} months`}
        </div>
      ) : (
        !isNull(data?.loanSuspension) && (
          <div
            className={`${
              data.loanStatus == "Suspended"
                ? "row-loan-suspend"
                : "row-loan-resume"
            } fw-500 ft-14`}
          >
            Loan was suspended on{" "}
            {usDateFormat(data?.loanSuspension?.suspensionStartDate)} and
            resumed on {usDateFormat(loanActivationDate)}
          </div>
        )
      )}
    </>
  );
};

export default ModificationDetails;
